export const generateMailtoLink = (
	subject: string,
	body: string = "",
	receiver: string = "support@bestell.bar"
) => {
	const encodedSubject = encodeURIComponent(subject);
	const encodedBody = encodeURIComponent(body);
	return `mailto:${receiver}?subject=${encodedSubject}&body=${encodedBody}`;
};
